module.exports = __webpack_public_path__ + "img/webPdfSign.3815fca9.svg";